import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class VegetativeStage extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_1.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Vegetative Stage
        </h2>
        <p>
        <span className="highlight">Timeline: 4 - 6 weeks</span>
        </p>
        <h3>Light Schedule</h3>
        <p>
        The vegetative stage it when your plant begins to take shape and grow. The plant will not flower during this stage, if it does, either something went wrong or you have an autoflowering strain, which flowers regardless of light schedule. During the vegetative stage it is important that you keep your plants on a strict light schedule of 18 hours or light and 6 hours of total darkness. You can experiment with lengthening the period of light to 20 or even 24 hours, but make sure your plants never get too long a dark period as they will begin to flower.
        </p>
        <p>
        Blue lights are ideal for the vegetative stage, although not a necessity if your light does not allow switching colors. At this point you’ll also want to begin adding nutrients catered to the vegetative stage. 
        </p>
        <h3>Flipping</h3>
        <p>
        It is recommended to keep the plants in a vegetative stage for about 4 - 6 weeks, although this is flexible. If you’re limited on space, you may want to flip your plants early when they’re about half the height of the total height your space allows. Alternatively, if you have the time and space you can keep your plants in a vegetative stage as long as you’d like. Some growers keep mother plants, which are plants that never leave the vegetative stage and whose only purpose is maintaining pure genetics for the purpose of producing consistent clones. 
        </p>
        <GuideButton slugTo="determining-gender" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_vegetative_stage.js